import React from 'react';
import Helmet from 'react-helmet';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import HousecallThemeProvider from 'housecall-ui/dist/DesignSystem/Styles/HousecallThemeProvider';
import CssBaseline from 'housecall-ui/dist/utils/CssBaseline';

import { QueryClientProvider } from './QueryClientProvider';

type Props = {
  children: React.ReactNode;
};

export const GeneralProviders = ({ children }: Props) => {
  return (
    <>
      <Helmet title="Online booking" />
      <CssBaseline />
      <HousecallThemeProvider>
        <QueryClientProvider>
          <BrowserRouter>
            <Switch>
              <Route path={['/book/:orgName/:token']}>{children}</Route>
            </Switch>
          </BrowserRouter>
        </QueryClientProvider>
      </HousecallThemeProvider>
    </>
  );
};
